module.exports = __webpack_public_path__ + "79a0d0570f89476475a9cd78a5436231.pdf";